import { Upload, X } from "lucide-react";
import { useRef } from "react";
import Loading from "../../shared/Loading";

const UploadSelfie = ({
  closeUploadSelfie,
  selectedFile,
  setSelectedFile,
  handleUploadFile,
  loading,
}) => {
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) setSelectedFile(file);
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  return (
    <div
      onClick={(e) => {
        closeUploadSelfie();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[980px] overflow-y-auto h-[600px] p-[20px] bg-white rounded-[10px] relative"
      >
        <div
          onClick={closeUploadSelfie}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <div className="absolute bottom-[10px] w-full px-[20px] right-0 flex items-center gap-[10px] justify-end">
          <button
            disabled={loading}
            onClick={handleUploadFile}
            className="bg-[#000000] h-[35px] px-[20px] rounded-[30px] text-[#ffffff] font-medium text-[15px] flex items-center justify-center gap-[5px]"
          >
            {loading && <Loading />}
            Save & Close
          </button>
        </div>
        <div>
          <p className="text-[#000000] font-normal text-[14px]">
            Add a Borrower Selfie
          </p>
          <p className="text-[#000000] font-semibold text-[20px]">
            Borrower’s Personal Details
          </p>
          <div className="flex w-full flex-col">
            <p className="text-[#222222] font-medium text-[13px]">
              Selfie{" "}
              <span className="font-normal text-[#5C5C5C]">
                .jpeg or .png file only
              </span>
            </p>
            <div
              onClick={triggerFileInput}
              className="h-[150px] flex flex-col justify-center items-center gap-[10px] rounded-[8px] border-[0.7px] border-[#A8A8A8] bg-white cursor-pointer"
            >
              {!selectedFile ? (
                <>
                  <Upload size={24} />
                  <p className="text-[#000000] text-[12px] font-normal text-center">
                    Drag and Drop file here or{" "}
                    <span className="text-[#000000] underline">
                      Choose file
                    </span>{" "}
                    here
                  </p>
                </>
              ) : (
                <p className="text-[#000000] text-[12px] font-medium text-center">
                  {selectedFile.name} ({(selectedFile.size / 1024).toFixed(1)}{" "}
                  KB)
                </p>
              )}
              <input
                ref={fileInputRef}
                type="file"
                accept=".jpeg,.png,.pdf,.jpg,.docs"
                className="hidden"
                onChange={handleFileChange}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadSelfie;
